import React from 'react';
import { gql } from '@soundxyz/gql-string';
import { UserActivityDetail } from '@components/Feed/User/UserActivityDetail';
import { ComponentContainer, ComponentWrapper } from '@components/Feed/shared';
import { PlaylistPreview } from '@components/Playlists/Preview';
import type { FragmentType } from '@graphql/reactQuery';
import { getFragment, LikedPlaylistFragmentDoc } from '@graphql/reactQuery';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment LikedPlaylist on UserLikedPlaylistAggregate {
    shelf {
      id

      ...PlaylistPreview
    }
    user {
      id
      ...UserActivityDetail
    }
  }
`);

export const LikedPlaylist = ({
  activityFrag,
  timeStamp,
}: {
  activityFrag: FragmentType<LikedPlaylistFragmentDoc>;
  timeStamp: number;
}) => {
  const { shelf: playlist, user } = getFragment(LikedPlaylistFragmentDoc, activityFrag);

  return (
    <ComponentContainer>
      {!!timeStamp && !!user && (
        <UserActivityDetail user={user} subText="liked a playlist" createdAt={timeStamp} />
      )}
      <ComponentWrapper onlyMargin>
        {!!playlist && <PlaylistPreview playlistFrag={playlist} />}
      </ComponentWrapper>
    </ComponentContainer>
  );
};
